<hr>
<div class="row">
    <div class="col-2"></div>
    <div class=" card border-info col-8" style="background-color: #112c41;" style="margin-bottom: 2%;">
       <div class="card-header"><p><b>SE DESIDERI RACCONTARE IL TUO PERCORSO CON ME O SEMPLICEMENTE
            TRASCRIVERE UNA RECENSIONE CHE DESCRIVA LA TUA ESPERIENZA CON ME,
           IL TUO GESTO SARÀ PER ME UN ENORME PIACERE.</b></p></div>
        <div class="card-body">
            <div class="row">
                <div class="col-md-3 text-center">
                    <img src="/assets/p2.jpg" style="margin-bottom: 2%; margin-top: 2%; width: 150px; length:150px">
                </div>
                <form [formGroup]="this.recensioniService.form">
                <div class="col-md-12 ">
                        <label  for="NomeInput" required  >Nome (Obbligatorio)</label>
                        <input type="text" formControlName="nome" class="form-control"  id="NomeInput" ngModel required>

                        <label for="CognomeInput">Cognome (Facoltativo)</label>

                        <input type="text" formControlName="cognome" class="form-control" id="CognomeInput">

                        <label for="DescrizioneInput">Scrivi la tua opinione!</label>
                    <div class="form-group">
                            <textarea id="DescrizioneInput" formControlName="description" rows="3"></textarea>
                    </div>
                </div>
                <span class="star-rating star-5">
  <input type="radio" formControlName="punteggio" name="rating" value="1"><i></i>
  <input type="radio" formControlName="punteggio" name="rating" value="2"><i></i>
  <input type="radio" formControlName="punteggio" name="rating" value="3"><i></i>
  <input type="radio" formControlName="punteggio" name="rating" value="4"><i></i>
  <input type="radio" formControlName="punteggio" name="rating" value="5"><i></i>
</span>
                    <button class="btn btn-lg btn-primary btn-block mb-1" (click)="onSubmit()" *ngIf="this.recensioniService.form.value.nome">
                        INVIA RECENSIONE
                    </button>
                </form>
            </div>
        </div>
    </div>
</div>
<br>
